import type { KpiCardSpec } from './card-spec';

/**
 * The Age verification scalar, shown on the Acquisition headline rows and the
 * Engagement page's Key metrics section. One object in every catalog, so no
 * two pages can report different figures for the same KPI.
 */
export const AGE_VERIFICATION_SCALAR_CARD: KpiCardSpec = {
    // Counts users who pass the gate, not users it blocks, so higher is
    // better and no `invertTrend` belongs here.
    title: 'Age verification',
    source: 'age-gating',
    form: 'number',
    metric: 'ageGatedUsers',
    size: 'sm',
    description:
        'New users of the selected period who completed age verification, counted on their signup date. This counts the users who passed the gate, not the ones it turned away, so a rise reads as more activation rather than more refusals.',
};
